import { DefaultTheme } from "styled-components"
import { LightTheme } from "./Theme"

export const DarkTheme: DefaultTheme = {
  ...LightTheme,
  textColor: "#FFF",
  backgroundColor: "#130304",
}
